import { PulseBaseProvider } from '../../base-classes';

const _allIconsUri = '/resources/v3/icons';
const _allIconsCacheKey = 'allIcons';

export class IconProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_allIconsCacheKey] = this.allIconsSyncer.bind(this);
    }

    async allIconsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const queryParams = {
            ...syncParams.stdParameters,
            iconSet: syncParams.iconSet,
            iconSize: syncParams.iconSize,
            contrast: syncParams.contrast,
            verbose: syncParams.verbose
        };
        return await super.syncData(syncParams.key, id, queryParams, _allIconsUri, resolve, reject, null, syncParams.pulseApi);
    }

    async getAllIcons(iconSet, iconSize, contrast, stdParameters, verbose, refresh = false) {
        const syncParams = {
            iconSet,
            iconSize,
            contrast,
            verbose: !!verbose,
            refresh
        };

        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_allIconsCacheKey, id);
        }
        return await super.loadFromStorage(_allIconsCacheKey, id, syncParams);
    }
}
